import { createAction } from 'redux-actions';
import {
  PapiDaSharedGallectionFolders,
  PapiRequestDaSharedGallectionFolders,
} from '@wix/da-papi-types';
import { actionKey } from '../constants';

export const fetchGallections = createAction(
  `${actionKey}.FETCH_GALLECTIONS`,
  (payload: {
    type: PapiRequestDaSharedGallectionFolders['type'];
    username?: string;
    folderId?: number;
    offset?: number;
    limit?: number;
    onSuccess?: (response: PapiDaSharedGallectionFolders) => void;
    onError?: (response: any) => void;
  }) => payload
);
